export default {"src":"/_next/static/media/chat-bubble.40f647c6.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};